<table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width: 100%;">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
  
    <!-- Position Column -->
    <ng-container matColumnDef="titulo">
      <th mat-header-cell *matHeaderCellDef> Nombre </th>
      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>
  
    <!-- Name Column -->
  
    <!-- Weight Column -->
    <ng-container matColumnDef="tipo">
      <th mat-header-cell *matHeaderCellDef> Tipo </th>
      <td mat-cell *matCellDef="let element"> {{element.tipo}} </td>
    </ng-container>

    <ng-container matColumnDef="mail">
      <th mat-header-cell *matHeaderCellDef> Mail </th>
      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>
  
    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> tags </th>
        <td mat-cell *matCellDef="let element">
            <button mat-stroked-button color="accent" (click)="editar(element)">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-stroked-button color="warn" (click)="eliminar(element)">
                <mat-icon>delete</mat-icon>
            </button>
        </td>
      </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>